export default function getResource(label, vars = []) {
    const resources = {
        youJustMissedThese: 'Vous les avez tout juste manqués',
        rougeBadge: 'ROUGE'
    };
    return resources[label];
}
